export default __webpack_public_path__ + "static/sprite-86de84bd54efc716175237078a842e75.svg";